import { useState } from 'react'
import * as React from 'react'
import AddressInput from './AddressInput'
import { SubmitButton } from '../components/SubmitButton'

type Props = {
  onSubmit: (address: string) => void
  loading: boolean
}

const WebsiteClaimAddressForm: React.FC<Props> = ({ onSubmit, loading }) => {
  const [address, setAddress] = useState<string | undefined>(undefined)

  const handleOnSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (address) {
      onSubmit(address)
    }
  }

  return (
    <div className="website-claim-address-form-container">
      <form onSubmit={handleOnSubmit}>
        <h2 className="website-claim-address-form-title">You are about to claim your POAP</h2>
        <p className="website-claim-address-form-message">Please input your email, ENS or Ethereum address below:</p>
        <AddressInput
          onAddress={(address) => {
            setAddress(address)
          }}
        />
        <SubmitButton
          type="submit"
          text="Mint POAP Token"
          className="btn"
          canSubmit={!!address}
          isSubmitting={loading}
        />
      </form>
    </div>
  )
}

export default WebsiteClaimAddressForm
